import { render, staticRenderFns } from "./shade-selector.vue?vue&type=template&id=d97b5f1e"
import script from "./shade-selector.vue?vue&type=script&lang=js"
export * from "./shade-selector.vue?vue&type=script&lang=js"
import style0 from "./shade-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports